import React from 'react'

function Navbar() {


    const toggleMenu = () => {
        document.getElementById('isToggle').classList.toggle('open');
        var isOpen = document.getElementById('navigation')
        if (isOpen.style.display === "block") {
            isOpen.style.display = "none";
        } else {
            isOpen.style.display = "block";
        }
      };

  return (
    <>
    
    <header id="topnav" className="defaultscroll sticky">
            <div className="container">
               
                <a className="logo" href="/">
                    <img src="/assets/images/mi-icon.png" height="24" className="logo-light-mode" alt="" />
                    <img src="/assets/images/mi-icon.png" height="24" className="logo-dark-mode" alt=""/>
                </a>                
           
                <div className="menu-extras">
                    <div className="menu-item">
                      
                        <a className="navbar-toggle" id="isToggle" onClick={toggleMenu}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </a>
                      
                    </div>
                </div>

        
 
                <ul className="buy-button list-inline mb-0">
                    {/* <li className="list-inline-item mb-0">
                        <a href="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                            <div className="btn btn-icon btn-pills btn-soft-primary"><i className="uil uil-cog align-middle" title="cog"></i></div>
                        </a>
                    </li> */}
            
                    <li className="list-inline-item ps-1 mb-0">
                        <a href="/login" >
                            <div className="btn btn-icon btn-pills btn-primary"><i data-feather="user" className="fea icon-sm"></i></div>
                        </a>
                    </li>
                </ul>
             

                <div id="navigation">
                  
                    <ul className="navigation-menu">
                        <li className='active'><a href="/" className="sub-menu-item">Эхлэл</a></li>
                        <li className="has-submenu parent-parent-menu-item">
                            <a href="#">Цэс</a><span className="menu-arrow"></span>
                            <ul className="submenu">
                                <li className="has-submenu parent-menu-item"><a href="#"> Байгууллага </a><span className="submenu-arrow"></span>
                                    <ul className="submenu">
                                        <li><a href="/about" className="sub-menu-item"> Бидний тухай</a></li>
                                        <li><a href="/service" className="sub-menu-item">Үйл ажиллагаа</a></li>
                                      {/*   <li><a href="/team" className="sub-menu-item"> Манай баг</a></li>
                                        <li><a href="/pricing" className="sub-menu-item">Үнэ</a></li> */}
                                    </ul> 
                                </li>
                                <li><a href="#" className="sub-menu-item">Бусад </a></li>
                                <li className="has-submenu parent-menu-item"><a href="#"> Холбоо барих </a><span className="submenu-arrow"></span>
                                    <ul className="submenu">
                                        <li><a href="/contact" className="sub-menu-item">Хаяг</a></li>
                                    </ul>  
                                </li>
                            </ul>
                        </li>

                        <li className="has-submenu parent-menu-item">
                            <a href="#">Бусад</a><span className="menu-arrow"></span>
                            <ul className="submenu">
                                <li><a href="/login" className="sub-menu-item">Нэвтрэх</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    </>
  )
}

export default Navbar